<template>
	<div class="container-list">
		<div class="common-page common-head">
			<div class="common-page common-head-title">
				<i class="icon-tr-other" style="padding-right: 5px"></i>
				单位信息
			</div>
		</div>
		<ul class="tab-wrap">
			<li
				:class="`tab-btn ${nowIndex == index && 'active'}`"
				@click="changeTab(index)"
				v-for="(tab, index) in tabList"
				v-show="!tab.disabled"
				:key="index"
				v-hasPermi="tab.permission"
			>
				<!-- v-hasPermi="tab.permission" -->
				{{ tab.title }}
			</li>
			<!-- <li
        :class="`tab-btn ${nowIndex == tabList.length && 'active'}`"
        @click="changeTab(tabList.length)"
        v-if="$route.query.id"
      >
        隐患信息
      </li> -->
		</ul>

		<!-- 隐患信息 -->
		<!-- <div v-show="nowIndex == tabList.length" v-if="$route.query.id">
      <danger :c_num="$route.query.id"></danger>
    </div> -->
		<!-- <div v-show="nowIndex==1"  v-if="$route.query.id">
    <reportcompany :is_tab="false" />
</div> -->
		<!-- 基本信息内容 -->
		<el-form ref="form" :model="form" label-width="110px" :rules="rules" class="mt20" v-show="nowIndex == 0">
			<el-row :gutter="20">
				<el-col :span="6">
					<el-form-item
						label="单位名称"
						:rules="{
							message: '请填写/选择',
							trigger: 'change',
							required: true,
						}"
						prop="base.c_name"
					>
						<el-input v-model="form.base.c_name" @blur="getInfoForName"></el-input>
					</el-form-item>
				</el-col>

				<el-col :span="6" style="">
					<el-form-item label="社会信用代码" prop="base.c_imployee_number " class="">
						<div class="flex">
							<el-input v-model="form.base.c_imployee_number" style="width: 10%"></el-input>
							<el-button size="mini" @click="getShui" :loading="shuiLoading">获取税号</el-button>
						</div>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="用户/服务类型" prop="base.c_port" style="width: 100%">
						<!-- <el-input v-model="form.base.c_port"></el-input> -->
						<el-col :span="12">
							<el-dropdown v-if="serviceTpEdit" size="small" class="ml20" style="width: 100%">
								<span class="cursor">
									请选择服务类型
									<i class="el-icon-arrow-down el-icon--right"></i>
								</span>
								<el-dropdown-menu slot="dropdown" class="tx-center" style="padding: 20px">
									<el-checkbox-group style="height: 30px" v-model="services" @change="handlechange">
										<el-checkbox label="3" key="监控">监控</el-checkbox>

										<el-checkbox label="1" key="评估">评估 </el-checkbox>
										<el-checkbox label="2" key="维保"> 维保</el-checkbox>
										<el-checkbox label="4" key="电检">电检</el-checkbox>

										<el-checkbox label="5" key="消检">消检</el-checkbox>
										<el-checkbox value="6" key="验收" label="6">验收</el-checkbox>
									</el-checkbox-group>
								</el-dropdown-menu>
							</el-dropdown>
							<span v-else>{{ form.base.portStr || "暂无类型" }}</span>
						</el-col>
						<el-col :span="12">
							<el-button @click="serviceTpEdit = !serviceTpEdit" v-hasPermi="['basic:company:port']"> {{ serviceTpEdit == false ? "修改" : "查看" }}</el-button>
						</el-col>
					</el-form-item>
				</el-col>

				<el-col :span="6">
					<el-form-item label="单位类型" prop="base.c_type">
						<el-col :span="12">
							<v-select v-if="companyTpEdit" :value.sync="form.base.c_type" :id="1" @updateValue='updateValueSllec'></v-select>
							<span v-else>{{ form.base.typeStr || "暂无类型" }}</span>
						</el-col>
						<el-col :span="12">
							<el-button @click="companyTpEdit = !companyTpEdit" v-hasPermi="['basic:company:type']"> {{ companyTpEdit == false ? "修改" : "查看" }}</el-button>
						</el-col>
					</el-form-item>
				</el-col>

				<el-col :span="6">
					<el-form-item label="所属辖区" prop="base.c_province" empty :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
					
						<el-cascader
							:options="area"
							v-model="areaValue"
							popper-class="cascader-popper"
							expandTrigger="hover"
							style="width: 100%;"
							@change="areaChange"
							:props="{
								value: 'areaCode',
								label: 'areaName',
								children: 'child',
								checkStrictly: true
							}"
						>
							<template slot-scope="{ node, data }">
								<span>{{ data.areaName }}</span>
							</template>
							<!-- <template slot-scope="scope">
								{{ scope.row }}
							</template> -->
						</el-cascader>
					</el-form-item>
				</el-col>

				<el-col :span="6">
					<el-form-item label="详细地址" prop="base.c_address">
						<el-input v-model="form.base.c_address"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="入网日期" prop="base.c_in_net">
						<el-date-picker type="date" placeholder="选择日期" v-model="form.base.c_in_net" value-format="yyyy-MM-dd"></el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="安全监管级别" prop="base.c_safe_level" :rules="{message: '请填写/选择',trigger: 'change',required: true}">
						<v-select :value.sync="form.base.c_safe_level" :id="38"></v-select>
					</el-form-item>
				</el-col>

				<el-col :span="6">
					<el-form-item label="所属行业" prop="base.c_belong_profession" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
						<v-select :value.sync="form.base.c_belong_profession" :id="66"></v-select>
					</el-form-item>
				</el-col>

				<el-col :span="6">
					<el-form-item label="联网状态" prop="base.c_net_status">
						<el-radio-group v-model="form.base.c_net_status">
							<el-radio :label="1">已联网</el-radio>
							<el-radio :label="0">未联网</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-col>

				<el-col :span="6">
					<el-form-item label="消防安全责任人" prop="base.c_responsible">
						<el-input v-model="form.base.c_responsible"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="责任人联系方式" prop="base.c_phone">
						<el-input v-model="form.base.c_phone"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="消防安全管理人">
						<el-input v-model="form.base.c_manager"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="管理人联系方式">
						<el-input v-model="form.base.c_manager_phone"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="点位数量" prop="base.c_woker">
						<el-input type="text" v-model="form.base.dwnum" disabled />
					</el-form-item>
				</el-col>

				<el-col :span="6">
					<el-form-item label="职工数" prop="base.c_woker">
						<el-input v-model="form.base.c_woker"></el-input>
					</el-form-item>
				</el-col>

				<el-col :span="6">
					<el-form-item label="占地面积" prop="base.c_land_area">
						<el-input v-model="form.base.c_land_area"></el-input>
					</el-form-item>
				</el-col>

				<el-col :span="6">
					<el-form-item label="总建筑面积" prop="base.c_total_area">
						<el-input v-model="form.base.c_total_area"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item
						label="单位性质"
						:rules="{
							message: '请填写/选择',
							trigger: 'change',
							required: true,
						}"
						prop="base.unit_nature"
					>
						<el-cascader style="width: 100%" v-model="unitnatureValue" :props="{ label: 'mc_name', value: 'mc_id' }" :options="PropertieOption" @change="handleChangeUnit">
							<template slot-scope="{ node, data }">
								<span>{{ data.mc_name }}</span>
							</template>
						</el-cascader>
					</el-form-item>
				</el-col>

				<el-col :span="6">
					<el-form-item
						v-if="unitnatureValue.length && (unitnatureValue.join(',') == '245,247' || unitnatureValue.join(',') == '245,248')"
						label="危险品存储量"
						prop="base.dangerous_capacity"
					>
						<!-- <el-option
                v-for="item in []"
                :key="item.value"
                :label="item.key"
                :value="item.value"
              ></el-option> -->
						<v-select :value.sync="form.base.dangerous_capacity" :id="266"></v-select>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item
						label="是否人员密集场所"
						:rules="{
							message: '请填写/选择',
							trigger: 'change',
							required: true,
						}"
						label-width="35%"
						prop="base.dense_places"
					>
						<el-radio-group v-model="form.base.dense_places">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-col>

				<el-col :span="6">
					<el-form-item label="邮箱" prop="base.email">
						<el-input v-model="form.base.email"></el-input>
					</el-form-item>
				</el-col>

				<!-- <el-col :span="6">
          <el-form-item label="级别" prop="base.c_level">
            <el-input v-model="form.base.c_level"></el-input>
          </el-form-item>
        </el-col> -->

				<!-- <el-col :span="6">
          <el-form-item label="类型" prop="base.c_profession_type">
            <el-input v-model="form.base.c_profession_type"></el-input>
          </el-form-item>
        </el-col> -->
				<el-col :span="6">
					<el-form-item label="东经" prop="base.lon" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
						<el-input v-model="form.base.lon" placeholder="请输入"></el-input>
						<getLoation @callback="getLoa" :local="form.base"></getLoation>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="北纬" prop="base.lat" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
						<el-input v-model="form.base.lat" placeholder="请输入"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="建筑产权单位" prop="base.c_power_company ">
						<el-input v-model="form.base.c_power_company"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item
						:rules="{
							message: '请填写/选择',

							trigger: 'change',
							required: true,
						}"
						label="是否自有产权"
						label-width="28%"
						prop="base.own_property_rights"
					>
						<el-radio-group v-model="form.base.own_property_rights">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-col>
				<!-- <el-col :span="24">
          <el-form-item label="消防隐患" prop="base.c_firefighting_messsage">
            <el-input v-model="form.base.c_firefighting_messsage"></el-input>
          </el-form-item>
        </el-col> -->
				<el-col :span="24">
					<!-- <el-col :span="6">
          <el-form-item label="消防管辖" prop="base.c_video_ip">
            <el-input v-model="form.base.c_video_ip"></el-input>
          </el-form-item>
        </el-col> -->

					<!-- <el-col :span="6" class="ml20">
                 <el-form-item label="租赁合同" prop="base.c_power_company ">
             
                              <fileUpload
                  v-model="form.base.leaseContractURL"
                  :uploadData="{ flagType: '0' }"
                  :fileType="['pdf','jpg','png','word']"
                  :fileUrl="'/oss/file/uploadFileFlag'"
                  :limit="5"
                  :fileSize="10"
                />
                 </el-form-item>
              </el-col> -->
					<el-col :span="6">
						<el-form-item
							label-width="35%"
							:rules="{
								message: '请填写/选择',
								trigger: 'change',
								required: true,
							}"
							label="最近消防站距离"
							prop="base.nearest_fire_station"
						>
							<!-- <el-select v-model="form.base.nearest_fire_station" >
              <el-option
                v-for="item in []"
                :key="item.value"
                :label="item.key"
                :value="item.value"
              ></el-option>
   
            </el-select> -->
							<v-select :value.sync="form.base.nearest_fire_station" :id="260"></v-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item
							:rules="{
								message: '请填写/选择',
								trigger: 'change',
								required: true,
							}"
							label="市政消火栓"
							prop="base.fire_hydrant"
						>
							<el-radio-group v-model="form.base.fire_hydrant">
								<el-radio :label="1">有</el-radio>
								<el-radio :label="0">无</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item
							:rules="{
								message: '请填写/选择',
								trigger: 'change',
								required: true,
							}"
							label="周围道路情况"
							prop="base.road_congestion"
						>
							<el-radio-group v-model="form.base.road_congestion">
								<el-radio :label="1">畅通</el-radio>
								<el-radio :label="2">拥堵</el-radio>
								<el-radio :label="3">非常拥堵</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="BIM" prop="base.isbim">
							<el-radio-group v-model="form.base.isbim">
								<el-radio :label="1">有</el-radio>
								<el-radio :label="0">无</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-col>
				<el-col :span="24">
					<el-form-item label="单位简介" prop="base.intro">
						<el-input type="textarea" :rows="5" v-model="form.base.intro"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<el-form-item label="监控备注" prop="base.remark">
						<el-input type="textarea" :rows="5" v-model="form.base.remark"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<!-- <el-row>
        <div class="f-right border-b">
          <div class="flex1">建筑消防设施列表</div>
        </div>

        <el-checkbox-group v-model="checkList">
          <el-form-item class="center">
            <div style="margin-left: 10px">
              <el-col
                :span="4"
                class="ml20"
                v-for="(item, index) in bulidList"
                :key="index"
              >
                <el-checkbox
                  v-for="(items, idx) in item"
                  :key="idx"
                  :label="items.key"
                  >{{ items.value }}</el-checkbox
                >
              </el-col>
            </div>
          </el-form-item>
        </el-checkbox-group>
      </el-row> -->
		</el-form>
		<duplicateCertificate v-if="nowIndex == 5 && isDuplicate"></duplicateCertificate>
		<!-- 建筑信息包含之后 -->
		<div v-for="(item, index1) in tabList" :key="index1" v-show="nowIndex == index1" v-if="index1 !== 0 && !(nowIndex == 5 && isDuplicate)">
			<div class="btn-box" v-if="!isDuplicate || nowIndex != 5">
				<div class="btn ml10" v-if="nowIndex == 5" v-hasPermi="['trmonitor:company:getOperatorDutyGroup']" @click="isDuplicate = true">
					使用重复证书
				</div>
				<div class="btn ml10" v-hasPermi="['basic:company:add']" v-if="nowIndex !== 2" @click="addList(index1)"><i class="icon-tr-newly-added"></i>新增</div>
			</div>
			<table class="common-table mt20" id="Table" row-key="goods_id">
				<thead>
					<!-- 选择 -->
					<div
						style="
              display: flex;
              width: 350px;
              height: 10px;
              margin-bottom: 30px;
              align-items: center;
            "
						v-if="nowIndex == 3"
					>
						<span style="width: 150px">设备类型：</span>
						<el-select v-model="selectValue" placeholder="请选择设备类型" size="small" @change="selectMethods" :curObj="curObj">
							<el-option :label="'全部'" value=""> </el-option>
							<el-option v-for="item in get_transmission_select" :key="item.mcId" :label="item.mcName" :value="item.mcId"> </el-option>
						</el-select>
					</div>
					<tr v-if="nowIndex !== 2">
						<th v-for="(data, index) in item.data" v-if="!data.disabled" :key="index">
							{{ data.text }}
						</th>
						<th>操作</th>
					</tr>
				</thead>

				<tbody>
					<!-- {{ form[tabList[index1].form] }} :group="groupName" -->
					<draggable
						@end="end"
						@start="start"
						@update="upd"
						:forceFallback="true"
						dragClass="dragClass"
						:move="onMove"
						fallbackClass="fallbackClass"
						chosenClass="chosenClass"
						ghostClass="ghostClass"
						style="width: 94vw"
					>
						<tr v-for="(data, index) in form[tabList[index1].form]" :key="index" class="trtdflex" v-if="!form[tabList[index1].form][index].hide">
							<td class="" v-for="(input, key, index2) in tabList[index1].data" :key="index2" v-if="!input.disabled" style="width:100%">
								<!-- :style="index == 1 ? 'width:14vw' : ''" -->

								<div v-if="input.type == 'select'">
									<v-select
										:value.sync="form[tabList[index1].form][index][input.form_name]"
										@changeValue="changeSelect"
										:id="input.op_id || input.option"
										:pid="input.pid"
										:mc_id="input.mc_id"
										:mcId="input.mcId"
										:mcName="input.mcName"
										:formName="input.form_name"
										:index="index"
										:curObj="curObj"
										:nowObj="form[tabList[index1].form][index]"
										:combineName="input.combineName"
										:combineValue="form[tabList[index1].form][index].combineValue"
										:combineId="input.combineId"
										:combineArray="input.combineArray"
										class="selectInp"
										filterable
									></v-select>
								</div>
								<el-date-picker
									type="date"
									value-format="yyyy-MM-dd"
									placeholder="选择日期"
									v-model="form[tabList[index1].form][index][input.form_name]"
									v-else-if="input.type == 'date'"
									style="width: 100%"
								></el-date-picker>
								<el-time-picker
									type="time"
									value-format="HH:mm:ss"
									placeholder="选择时间"
									v-model="form[tabList[index1].form][index][input.form_name]"
									v-else-if="input.type == 'timmer'"
								></el-time-picker>

								<!-- <imageUpload v-else-if="input.type == 'uploadImg'" :fileUrl="'/oss/file/uploadFileFlag'"
									v-model="form[tabList[index1].form][index][input.form_name]" :uploadData="{ flagType: '0' }"
									:fileType="['dwg','pdf','jpg','png','zip','rar']"
									
									:limit="5"
									:fileSize="10"/> -->
								<fileUpload
									v-else-if="input.type == 'uploadImg'"
									v-model="form[tabList[index1].form][index][input.form_name]"
									:uploadData="{ flagType: '0' }"
									:fileType="['jpg', 'png']"
									:fileUrl="'/oss/file/uploadFileFlag'"
									:fileSize="10"
									:limit="1"
								/>

								<el-input placeholder="请输入" v-model="form[tabList[index1].form][index][input.form_name]" :type="input.type" v-else></el-input>
							</td>

							<td class="td-btn" style="width:50%;">
								<a class="clear-data" @click="del(index)">
									<i class="icon-tr-delete"></i>
								</a>
							</td>
						</tr>
					</draggable>
				</tbody>
				<!-- {{ tabList[index1].data[2].options }}
        {{ tabList[index1].data[2].text }} -->
			</table>
			<el-row class="mt20 ml20" v-if="nowIndex == 1">
				<div class="f-right ml20">
					<div class="flex1 mt20">建筑资料</div>
				</div>
				<el-col :span="24" class="ml20 mt20">
					<div class="flex">
						<span>上传图纸资料：</span>
						<fileUpload
							v-model="form.base.buildDrawInfoURL"
							:uploadData="{ flagType: '0' }"
							:fileType="['dwg', 'pdf', 'jpg', 'png', 'zip', 'rar']"
							:fileUrl="'/oss/file/uploadFileFlag'"
							:limit="5"
							:fileSize="30"
						/>
					</div>
				</el-col>
				<el-col :span="24" class="ml20 mt20">
					<div class="flex">
						<span>上传审批手续资料:</span>

						<fileUpload
							v-model="form.base.buildApprovalProcedureInfoURL"
							:uploadData="{ flagType: '0' }"
							:fileType="['pdf', 'jpg', 'png', 'zip', 'rar']"
							:fileUrl="'/oss/file/uploadFileFlag'"
							:fileSize="30"
							:limit="5"
						/>
					</div>
				</el-col>
				<el-col :span="24" class="ml20 mt20">
					<div class="flex">
						<span>上传建筑总平面布局图:</span>

						<fileUpload
							v-model="form.base.buildGeneralPlanUrl"
							:uploadData="{ flagType: '0' }"
							:fileType="['dwg', 'pdf', 'jpg', 'png', 'zip', 'rar']"
							:fileUrl="'/oss/file/uploadFileFlag'"
							:fileSize="30"
							:limit="5"
						/>
					</div>
				</el-col>

				<el-col :span="24" class="ml20 mt20">
					<div class="flex">
						<span>上传建筑内部平面布局图:</span>

						<fileUpload
							v-model="form.base.buildInternalPlaneUrl"
							:uploadData="{ flagType: '0' }"
							:fileType="['dwg', 'pdf', 'jpg', 'png', 'zip', 'rar']"
							:fileUrl="'/oss/file/uploadFileFlag'"
							:fileSize="30"
							:limit="5"
						/>
					</div>
				</el-col>

				<el-col :span="24" class="ml20 mt20">
					<div class="flex">
						<span>上传建筑消防设施平面布置图:</span>

						<!-- {{ headers }} -->

						<fileUpload
							v-model="form.base.buildFacilityPlanUrl"
							:uploadData="{ flagType: '0' }"
							:fileType="['dwg', 'pdf', 'jpg', 'png', 'zip', 'rar']"
							:fileUrl="'/oss/file/uploadFileFlag'"
							:fileSize="30"
							:limit="5"
						/>
					</div>
				</el-col>
			</el-row>
		</div>
		<!-- 消防设施开始 -->
		<div class="mt20" v-show="nowIndex == 2">
			<div class="fireFacilities">
				<h3 class="firehead">建筑消防设施列表</h3>
				<el-button size="small" plain type="primary" style="margin-right: 15px; height: 40px" @click="$router.push('/fireFacilities/managementFacilities')">编辑</el-button>
			</div>
			<div class="fireFacilities">
				<div :style="fireList == null ? 'width:0' : 'width:15%'">
					<ul class="firebiao">
						<li :class="fireCurrentIndex == index ? 'fireHead1' : 'fireHead'" v-for="(item, index) in fireList" @click="fireClick(item, index)">
							{{ item.name }}
						</li>
					</ul>
				</div>
				<div class="fireCenter"></div>
				<div class="fireFightingRight" :style="fireList == null ? 'width:90%' : 'width:75%'">
					<div class="fireFightingRight_border" v-for="(item, index) in fireFacilitiesDetailList.fireFacilitiesMiddleList">
						<el-collapse accordion v-model="activeNames">
							<el-collapse-item :name="index">
								<template slot="title">
									<h3 class="monitor_device">
										{{ item.name || "系统功能" }}
									</h3>
									<div class="monitor_count">
										数量：<span>{{ item.num || 0 }}</span>
									</div>
								</template>
								<div class="fireFightingRight_count" v-for="(item1, index1) in item.fireFacilitiesFunctionList" :key="index1">
									<!-- 消防水源表格 -->
									<div v-if="fireFacilitiesDetailList.systemNum == 12" class="fireFightingRight_count_detail1">
										<div class="fireFightingRight_count_detail">
											<p style="margin: 8px 5px">容积</p>
											<input disabled class="fireInput" v-model="item1.volume" :placeholder="item1.volume || '暂无'" type="text" />
										</div>
										<div class="fireFightingRight_count_detail">
											<p style="margin: 8px 5px">位置</p>
											<input disabled class="fireInput" v-model="item1.position" :placeholder="item1.position || '暂无'" type="text" />
										</div>
									</div>
									<!-- 普通表格 -->
									<div v-else class="fireFightingRight_count_detail1">
										<div class="fireFightingRight_count_detail">
											<p style="margin: 8px 5px">品牌、生产厂家</p>
											<input disabled class="fireInput" v-model="item1.brand" :placeholder="item1.brand || '暂无'" type="text" />
										</div>
										<div class="fireFightingRight_count_detail">
											<p style="margin: 8px 5px">规格型号</p>
											<input disabled class="fireInput" v-model="item1.specificationsModel" :placeholder="item1.specificationsModel || '暂无'" type="text" />
										</div>
										<div class="fireFightingRight_count_detail">
											<p style="margin: 8px 5px">生产年份</p>
											<el-date-picker disabled value-format="yyyy-MM-dd HH:mm:ss" v-model="item1.prodDate" type="datetime" class="fireInput" placeholder="选择日期时间">
											</el-date-picker>
										</div>
									</div>
									<div class="fireFightingRight_count_detail1" v-if="item1.fireFacilitiesRemarkList">
										<div class="fireFightingRight_count_detail" v-for="item2 in item1.fireFacilitiesRemarkList">
											<p style="margin: 8px 5px">{{ item2.name }}</p>
											<input disabled class="fireInput" v-model="item2.value" :placeholder="item2.value || '暂无'" type="text" />
										</div>
										<!-- 防烟排烟系统 -->
										<div v-if="fireFacilitiesDetailList.systemNum == 25" class="fireFightingRight_count_detail">
											<p style="margin: 8px 5px">风量</p>
											<input disabled class="fireInput" v-model="item1.airVolume" :placeholder="item1.airVolume || '暂无'" type="text" />
										</div>
										<!--消火栓系统  -->
										<div v-if="fireFacilitiesDetailList.systemNum === 15" class="fireFightingRight_count_detail">
											<p style="margin: 8px 5px">流量(L/S)</p>
											<input disabled class="fireInput" v-model="item1.flow" :placeholder="item1.flow || '暂无'" type="text" />
										</div>
										<div v-if="fireFacilitiesDetailList.systemNum === 15" class="fireFightingRight_count_detail">
											<p style="margin: 8px 5px">扬程(m)</p>
											<input disabled class="fireInput" v-model="item1.lift" :placeholder="item1.lift || '暂无'" type="text" />
										</div>
										<!--自动喷水灭火系统  -->
										<div v-if="fireFacilitiesDetailList.systemNum === 18" class="fireFightingRight_count_detail">
											<p style="margin: 8px 5px">流量(L/S)</p>
											<input disabled class="fireInput" v-model="item1.flow" :placeholder="item1.flow || '暂无'" type="text" />
										</div>
										<div v-if="fireFacilitiesDetailList.systemNum === 18" class="fireFightingRight_count_detail">
											<p style="margin: 8px 5px">扬程(m)</p>
											<input disabled class="fireInput" v-model="item1.lift" :placeholder="item1.lift || '暂无'" type="text" />
										</div>
									</div>
								</div>
							</el-collapse-item>
						</el-collapse>
						<!-- <div class="monitor">v-model="activeNames"
            <h3 class="monitor_device">监控设备</h3>
            <div class="monitor_count">数量：<span>2</span></div> 
            
            <img src="@/assets/img/pulldown.png" class="pulldown">
          </div> -->
					</div>
					<div class="fireQuestion">
						<h3 class="fireQuestionP">其它问题说明</h3>
						<el-input disabled v-if="fireList == null" type="textarea" placeholder="请输入内容"></el-input>
						<el-input v-else disabled type="textarea" placeholder="请输入内容" v-model="fireFacilitiesDetailList.explanation"> </el-input>
					</div>
				</div>
			</div>
		</div>
		<!-- 消防设施结束 -->

		<el-dialog :visible.sync="dialogVisible" width="60%">
			<img width="100%" :src="viewImgUrl" alt="" />
		</el-dialog>
		<div class="center" v-if="nowIndex !== tabList.length">
			<div :ref="nowIndex == 1 && nowIndex !== 2 ? '' : 'subBtn'" class="l-btn" v-hasPermi="['basic:company:add']" v-if="!isDuplicate && nowIndex !== 2" @click="onSubmit">
				保存
			</div>
			<div class="l-btn ml20" style="margin: 10px" @click="isDuplicate && nowIndex == 5 ? (isDuplicate = !isDuplicate) : $router.back(-1)">
				返回
			</div>
		</div>
		<el-backtop target=".common-body-style" :title="'返回顶部'" :visibility-height="180"></el-backtop>
	</div>
</template>

<script>
	import { addCompany, editCompany } from "../../api/company";
	import { getAreaNew } from "../../api/common";
	import { sigtype, port, SecondPort } from "./options";
	import OSS from "ali-oss";
	import { buildList } from "./build-list";

	import getLoation from "./getLoation";
	import danger from "./danger";
	import reportcompany from "@/components/reportcomp";
	import duplicateCertificate from "./components/duplicateCertificate.vue";
	import draggable from "vuedraggable";

	export default {
		data() {
			return {
				cacheSelected: [],
				menuName: "", //新增菜单名称
				dialogVisibleMenu: false,
				updateMenuoading: false,
				menuDialogName: "新增菜单",

				destIndex: -1, //要交换的目标元素下标
				srcIndex: -1, //要交换的起始元素下标
				selectValue: "", // 类型选择
				selectValueKey: "", // 类型id
				fireFacilitiesDetailList: { fireFacilitiesMiddleList: 1 },
				activeNames: [],
				fireCurrentIndex: 0,
				fireList: ["电气火灾监控系统", "电气火灾监控系统"],
				id: this.$route.query.id,
				isDuplicate: false,
				services: [],
				shuiLoading: false,
				dialogVisible: false,
				viewImgUrl: "",
				area: [],
				areaValue: ["370000", "370200", "370202", "3710821"],
				unitnatureValue: [],
				shangjioption: [],
				serviceTpEdit: false, // 是否可编辑 服务类型
				companyTpEdit: false,
				bulidList: buildList, // 维保项
				checkList: [], //维保选项
				yuanqvoption: [],
				loada: false,
				fileList: {},
				// 单位性质选择
				PropertieOption: [],
				form: {
					base: {
						// c_number: "",
						c_type: 2,
						c_superior: "",
						c_part: "",
						c_name: "",
						c_phone: "",
						c_manager_phone: "",
						c_power_company: "",
						c_in_net: "",
						c_net_status: "",
						c_province: "370000",
						c_city: "370200",
						c_area: "370202",
						c_street: null,
						c_address: "",
						c_setup_table: "",
						isbim: "",
						// c_level: "",
						leaseContractURL: "", // 上传租赁合同资料
						buildApprovalProcedureInfoURL: "", //   上传审批手续资料
						buildDrawInfoURL: "", //上传审批手续资料

						buildGeneralPlanUrl: "", // 上传建筑总平面布局图
						buildInternalPlaneUrl: "", // 上传建筑内部平面布局图
						buildFacilityPlanUrl: "", // 上传建筑消防设施平面布置图

						c_safe_level: "",
						c_belong_profession: "",
						// c_profession_type: "",
						email: "",
						c_responsible: "",
						c_manager: "",
						c_imployee_number: "",
						// c_department_responsible: "",
						c_woker: "",
						c_land_area: "",
						unit_nature: "",

						dangerous_capacity: "",
						dense_places: "",
						own_property_rights: "",
						nearest_fire_station: "",
						fire_hydrant: "",
						road_congestion: "",

						c_total_area: "",
						intro: "",
						// c_video_filter: "",
						// c_video_ip: "",
						c_port: "",
						c_plugin_type: "",
						remark: "",
						lat: "",
						lon: "",
					},
					get_build: [],
					// get_control: [],
					// get_server: [],
					get_facility: [],
					get_transmission: [],
					get_interface: [],
					get_message: [],
					get_onduty: [],
					get_video: [],
					get_area: [],
					get_rate: [],
					get_transmission_select: [],
					// get_emphasis:[]
				},
				curObj: null,

				rules: {},
				nowIndex: 0,
				allAreaList: [],
				cityList: [],
				areaList: [],
				tabList: [
					{ title: "基本信息", disabled: false, form: "base", permission: "" },
					// {title:"报告信息",disabled:false,form:''},
					{
						title: "建筑信息",
						disabled: false,
						form: "get_build",
						permission: ["system:company:build"],

						data: [
							{ form_name: "cb_name", type: "text", text: "建筑名称" },
							{ form_name: "cb_area", type: "text", text: "建筑面积" },

							{
								form_name: "cb_use_type",
								type: "select",
								text: "使用性质",
								option: [
									{ mc_id: "1", mc_name: "工业-甲乙类仓库厂房" },
									{ mc_id: "2", mc_name: "工业-其他类仓库厂房" },
									{ mc_id: "3", mc_name: "民用-公共" },
									{ mc_id: "4", mc_name: "民用-住宅" },
								],
							},
							{ form_name: "cb_height", type: "text", text: "高度" },
							{ form_name: "cb_on", type: "text", text: "地上层数" },
							{ form_name: "cb_under", type: "text", text: "地下层数" },
							// {form_name: 'cb_yinqing', type: 'text', text: '火灾引擎'},
						],
					},

					// {title: '消防重点部位',disabled:false,form:"get_emphasis" ,data:[
					//   { form_name: "zd_name", type: "text", text: "部位名称" },
					//    { form_name: "zd_address", type: "text", text: "所在位置" },
					//     { form_name: "zd_nature", type: "text", text: "使用性质" },
					//     { form_name: "zd_area", type: "text", text: "建筑面积" },

					//      { form_name: "zd_level", type: "text", text: "耐火等级" },
					//       { form_name: "zd_facility", type: "select", text: "有无消防设施" , option: [
					//         { mc_id: 1, mc_name: "有" },
					//         { mc_id: 0, mc_name: "无" },
					//       ],},

					//       { form_name: "zd_duty_name", type: "text", text: "责任人姓名" },

					//       { form_name: "zd_duty_card", type: "text", text: "身份证号码" },

					//       { form_name: "zd_duty_phone", type: "text", text: "电话" }

					// ]},

					{
						title: "消防设施",
						disabled: false,
						// form: "get_facility",
						permission: ["system:company:fireFight"],
						data: [
							// { form_name: "cf_name", type: "text", text: "消防设施名称" },
							// { form_name: "cf_brand", type: "text", text: "消防品牌" },
							// { form_name: "cf_norm", type: "text", text: "规格型号" },
							// { form_name: "cf_node", type: "text", text: "节点数" },
							// { form_name: "cf_quantity", type: "text", text: "数量" },
						],
					},
					{
						title: "传输装备",
						permission: ["system:company:transmission"],
						// disabled: !(this.$store.state.user.userInfo.userId == 1),
						form: "get_transmission",
						data: [
							{
								form_name: "ct_transmission_num",
								type: "text",
								text: "设备编号",
							},
							{
								form_name: "ct_transmission_type",
								type: "select",
								text: "设备类型",
								op_id: 28,
							},
							{
								form_name: "ct_transmission_model",
								type: "text",
								text: "设备型号",
							},
							{ form_name: "ct_child_number", type: "text", text: "子号" },
							{ form_name: "ct_part_num", type: "text", text: "部位号" },
							{
								form_name: "ct_transmission_name",
								type: "text",
								text: "设备名称",
							},
							{ form_name: "ct_heart_beat", type: "text", text: "心跳时间(s)" },
							{ form_name: "ct_local", type: "text", text: "安装位置" },
							{ form_name: "ct_setup_data", type: "date", text: "安装日期" },
							{ form_name: "ct_open_date", type: "date", text: "开通日期" },
						],
					},
					{
						title: "接口资料",
						permission: ["system:company:interface"],
						// disabled: !(this.$store.state.user.userInfo.userId == 1),
						form: "get_interface",
						data: [
							{ form_name: "ci_num", type: "text", text: "设备编号" },
							{ form_name: "ci_snum", type: "text", text: "子号" },
							{
								form_name: "ci_message_type",
								type: "select",
								text: "信号类型",
								op_id: 171,
							},
							{
								form_name: "ci_sys_type",
								type: "select",
								text: "系统类型",
								op_id: 16,
							},
							{
								form_name: "ci_port",
								type: "select",
								text: "端口号",
								option: port,
							},
							{ form_name: "ci_device_name", type: "text", text: "信号名称" },
							{
								form_name: "ci_info_type",
								type: "select",
								text: "信号分类",
								option: sigtype,
							},
							{ form_name: "ci_simulation_sys", type: "text", text: "模拟系数" },
							{ form_name: "ci_cap", type: "text", text: "上限" },
							{ form_name: "ci_lower", type: "text", text: "下限" },
							{ form_name: "water_height", type: "text", text: "水箱高度" },

							{ form_name: "ci_unit", type: "text", text: "单位" },
							{
								form_name: "deviceType",
								type: "select",
								text: "所属设备",
								op_id: "device",
								pid: "ci_sys_type",
								disabled: !this.$route.query.id,
							},
							{
								form_name: "relayType",
								type: "select",
								text: "继电器类型",
								op_id: 291,
								combineName: "ci_message_type",
								combineId: 290,
								combineArray: [292, 293, 294, 295],
							},
							{
								form_name: "bindPort",
								type: "select",
								text: "第二端口",
								option: SecondPort,
								combineName: "relayType",
								combineId: 293,
								combineArray: ["A01", "A02", "A03", "A04"],
							},
						],
					},
					// {
					//   title: "消防服务",
					//   disabled:false,form: "get_server",
					//   data: [
					//     { form_name: "cd_unit_name", type: "text", text: "单位名称" },
					//     {
					//       form_name: "create_time",
					//       type: "date",
					//       text: "开始时间",
					//     },
					//     { form_name: "cd_user", type: "text", text: "联系人" },
					//     { form_name: "cd_phone", type: "text", text: "联系人电话" },
					//   ],
					// },
					// {
					//   title: "消控室",
					//   disabled:false,form: "get_control",
					//   data: [
					//     { form_name: "cc_num", type: "text", text: "消控室编号" },
					//     { form_name: "cc_name", type: "text", text: "消控室名称" },
					//     { form_name: "cc_build", type: "text", text: "所属建筑" },
					//     { form_name: "cc_address", type: "text", text: "地址" },
					//     { form_name: "cc_user", type: "text", text: "责任人" },
					//     { form_name: "cc_device", type: "text", text: "设备" },
					//   ],
					// },
					{
						title: "值班操作人员",
						permission: ["system:company:operatorDuty"],
						disabled: false,
						form: "get_onduty",
						data: [
							{ form_name: "co_name", type: "text", text: "姓名" },
							{ form_name: "co_phone", type: "text", text: "电话" },
							{ form_name: "certificate_no", type: "text", text: "证书编号" },
							{
								form_name: "certificate_url",
								type: "uploadImg",
								text: "上传证书",
							},
						],
					},
					{
						title: "短信通知",
						permission: ["system:company:sms"],
						disabled: false,
						form: "get_message",
						data: [
							{ form_name: "cm_name", type: "text", text: "姓名" },
							// {form_name: 'cm_post', type: 'text', text: '岗位'},
							{ form_name: "cm_phone", type: "text", text: "电话" },
							{
								form_name: "cm_push",
								type: "select",
								text: "是否推送",
								option: [
									{ mc_id: 1, mc_name: "是" },
									{ mc_id: 0, mc_name: "否" },
								],
							},
							{
								form_name: "cm_push_type",
								type: "select",
								text: "推送类型",
								option: [
									{ mc_id: "火警", mc_name: "火警" },
									{ mc_id: "水位超限", mc_name: "水位超限" },
									{ mc_id: "水压超限", mc_name: "水压超限" },
									{ mc_id: "漏电流超限", mc_name: "漏电流超限" },
									{ mc_id: "温度超限", mc_name: "温度超限" },
								],
							},
						],
					},
					{
						title: "视频监控",
						permission: ["system:company:video"],
						disabled: false,
						form: "get_video",
						data: [
							{ form_name: "v_video_ip", type: "text", text: "视频ip" },

							{ form_name: "v_video_address", type: "text", text: "位置信息" },
							{ form_name: "username", type: "text", text: "用户名" },
							{ form_name: "password", type: "password", text: "密码" },
							{ form_name: "channel", type: "text", text: "通道名称" },
							{
								form_name: "isonly",
								type: "select",
								text: "是否线上",
								option: [
									{ mc_id: 1, mc_name: "是" },
									{ mc_id: 2, mc_name: "否" },
								],
							},
							{
								form_name: "v_video_kind",
								type: "select",
								text: "摄像头品牌",
								op_id: 215,
							},
							{ form_name: "v_video_url", type: "text", text: "服务器网址" },
						],
					},

					// {
					//   title: "巡查区域",
					//   disabled:false,form: "get_area",
					//   data: [
					//     { form_name: "x_company_area", type: "text", text: "区域" },
					//   ],
					// },     {
					//   title: "巡查时间",
					//   disabled:false,form: "get_rate",
					//   data: [
					//     { form_name: "start_time", type: "timmer", text: "时间" },
					//     { form_name: "z_status", type: "select", text: "是否启用",  option: [
					//         { mc_id: 1, mc_name: "是" },
					//         { mc_id: 0, mc_name: "否" },

					//       ] },

					//   ],
					// },
				],
			};
		},
		// computed: {
		//   filterBaseTitle() {
		//     var search = this.selectValue;
		//     // this.get_transmission_select = this.get_transmission_select.filter((item) => this.form.get_transmission.includes(item.ct_transmission_name));
		//     if (search === '') return this.form[this.tabList.form];
		//     else if (search) {
		//       return this.tabList.filter(function(tabList) {
		//         return Object.keys(tabList).some(function(key) {
		//           return String(tabList[key]).indexOf(search) > -1;
		//         });
		//       });
		//     }
		//     return this.tabList;
		//   },
		// },
		created() {
			// 获取单位性质

			var mapIdArr = [171, 18, 16, 215, 28, 291];

			mapIdArr.map((item) => {
				this.getMapCode(item);
				// log(item, 'mapCode数据获取');
			});
			getAreaNew().then((res) => {
				log(res, 123123);
				this.area = res.data;
			});
			this.$get("/trxf/main/xf/mapCode/Tree", { mcDesc: "unit_nature" }).then((res) => {
				const checkChildren = (arr) => {
					if (arr.length) {
						arr.map((it) => {
							if (it.children.length) {
								checkChildren(it.children);
							} else {
								delete it.children;
							}
						});
					}
				};
				this.PropertieOption = res.data[0].children;

				checkChildren(this.PropertieOption);

				// console.log(this.PropertieOption);
			});

			this.$post("/trxf/main/xf/danwei/xfdanweixinxi/querybasemap").then((res) => {
				var arr = [];
				var arr1 = [];
				res.data[0].map((item, index) => {
					arr.push({ key: item.c_name, value: item.company_num });
				});
				res.data[1].map((item, index) => {
					arr1.push({ key: item.c_name, value: item.company_num });
				});
				arr.unshift({ key: "无", value: "0" });
				arr1.unshift({ key: "无", value: "0" });

				this.shangjioption = arr;
				this.yuanqvoption = arr1;
			});
			if (this.$route.query.id) {
				this.getList();
			}
		},
		mounted() {
			// 获取消防设施列表
			
			this.getFireList();
		},
		components: {
			getLoation,
			danger,
			reportcompany,
			duplicateCertificate,
			draggable,
		},
		watch: {
			dialogVisible(v) {
				log(v, "触发dialogVisible");
				if (!v) {
					this.viewImgUrl = "";
				}
			},
		},

		methods: {
			// ceshi(e){
			// 	console.log(e,55555555)
			// },
			updateValueSllec(v){
				// console.log(v,this.form.base.typeStr);
				if (v==2) {
					this.form.base.typeStr='联网单位'
				}else if (v==3) {
					this.form.base.typeStr='消防监管单位'
				}else if (v==3) {
					this.form.base.typeStr='消防监管单位'
				}else if (v==4) {
					this.form.base.typeStr='维保单位'
				}else if (v==5) {
					this.form.base.typeStr='报警单位'
				}else if (v==217) {
					this.form.base.typeStr='监控单位'
				}else if (v==218) {
					this.form.base.typeStr='其他'
				}
			},
			// 表格拖拽
			initSort() {
				const el = document.querySelectorAll(".el-table__body-wrapper > table > tbody")[0];
				// const sortable = new Sortable(el, options);
				// 根据具体需求配置options配置项
				const sortable = new Sortable(el, {
					onEnd: (evt) => {
						// 监听拖动结束事件
						console.log(this); // this是当前vue上下文
						console.log(evt.oldIndex); // 当前行的被拖拽前的顺序
						console.log(evt.newIndex); // 当前行的被拖拽后的顺序
						// 这里就可以写我们需要传给后台的逻辑代码
						// 我们有了 evt.oldIndex 和 evt.newIndex 这两个参数做索引，我们可以根据绑定在表格上面的 data 这个 Array 找到两个相应的记录。就可以针对数据进行操作啦。
						// 下面将拖拽后的顺序进行修改
						const currRow = this.list.splice(evt.oldIndex, 1)[0];
						this.list.splice(evt.newIndex, 0, currRow);
						const newData = [];
						this.list.forEach((item, index) => {
							newData[index] = {
								id: item.id,
								rank: index + 1,
							};
						});
						// 下面是将排序结果更新到数据库中，根据自己项目的逻辑进行实现即可。
						const data = {
							id: this.$route.params.id,
							datas: {
								streams: newData,
							},
						};
						this.$store
							.dispatch("user/setMultiSort", data)
							.then((res) => {
								if (res.code === 200) {
									// this.$message.success("排序修改成功");
									this.$message({ 
										message: "排序修改成功", 
										type: "success", 
										duration: 700,});
								
									// 修改成功后重新获取列表数据更新
									this.getMultiLiveList();
								} else {
									// this.$message.error("排序修改失败");
									this.$message({ 
										message: "排序修改失败", 
										type: "error", 
										duration: 700,});
								}
							})
							.catch((e) => {
								console.log(e);
							});
					},
				});
			},
			upd(e, u) {
				// console.log('update', e)
			},
			start(e) {
				this.srcIndex = e.oldIndex; //开始拖拽的元素下标（位置）
				// console.log("srcIndex==来源下标" + this.srcIndex)
			},
			end({ to, from, item, clone, oldIndex, newIndex }) {
				//松开鼠标时触发
				// console.log('end111')
				// console.log("from" + from)
				// console.log(from)
				// console.log("to" + to)
				// console.log(to)
				// console.log("item" + item)
				// console.log(item)
				// console.log("endIndex==结束下标" + this.destIndex)
				// console.log("oldIndex==oldIndex" + this.oldIndex)
				// console.log("newIndex==newIndex" + this.newIndex)
				//开始拖拽的元素和拖拽目的元素交换位置
				// let lastItem = this.sortList[this.destIndex];
				// let firstItem = this.sortList[this.srcIndex];
				// this.sortList.splice(this.srcIndex, 1, lastItem)
				// this.sortList.splice(this.destIndex, 1, firstItem)
				// this.destIndex = -1;
			},
			onMove(e, originalEvent) {
				//占位图移动到目标位置时触发
				// console.log('move11')
				this.destIndex = e.draggedContext.futureIndex; //每次拖拽移动记住当前拖拽到的位置
				return false;
			},

			selectMethods(val) {
				if (val == "") return this.getList();
				// else log(this.get_transmission.filter((it) => it.ct_transmission_type.toString() === this.selectValue));
				// this.form.get_transmission = this.get_transmission.filter((it) => it.ct_transmission_type.toString() === this.selectValue);
				// 使用某一个字段来控制显示隐藏
				else
					this.form.get_transmission = this.get_transmission.map((it) => {
						it.hide = it.ct_transmission_type.toString() !== this.selectValue;
						return it;
					});
				// this.getList();
			},
			// 消防设施列表（左侧）
			getFireList() {
				this.$get("/fireFacilities/fireFacilitiesSystem/getFacilitiesInfoExist/" + this.id).then((res) => {
					this.fireList = res.data;
					if (this.fireList == null) {
						this.fireFacilitiesDetailList.fireFacilitiesMiddleList = 1;
						return;
					}
					this.fireClick(this.fireList[0], 0);
				});
			},
			// 消防建筑
			fireClick(item, index) {
				this.fireCurrentIndex = index;
				this.$get("/fireFacilities/fireFacilitiesSystem/getInfo?companyNum=" + this.id + "&systemNum=" + item.code).then((res) => {
					// console.log(res.data, 111);
					this.fireFacilitiesDetailList = res.data;
				});
			},
			getInfoForName(e) {
				if (this.form.base.c_name && this.$store.state.user.userInfo.natureId == 3 && this.$store.state.user.userInfo.userId !== 1)
					this.$get("/trmonitor/company/getCompanyNumByName", {
						name: this.form.base.c_name,
					}).then((res) => {
						if (res.data)
							this.$confirm("该单位已存在,是否将该单位存入本账号下?", "提示", {
								confirmButtonText: "确定",
								cancelButtonText: "取消",
								type: "warning",
							})
								.then(() => {
									this.$get("/trmonitor/company/companyPullToUser", {
										companyNum: res.data,
									}).then((re) => {
										this.$message({
											message: "添加成功",
											type: "success",
										});
										this.$router.back();
									});
								})
								.catch(() => {
									// this.$message({ type: "info", message: "" });
								});
					});
				// this.getList();
			},
			changeSelect(v) {
				this.curObj = v;
				/**
				 * start
				 * @todo 只在接口资料页面调用
				 */
				// if(){}
				const combineValue = {
					...this.form.get_interface[v.index].combineValue,
				};
				combineValue[v.formName] = v.val;
				if (combineValue.ci_message_type != 290) {
					combineValue.relayType = "";
				}
				this.form.get_interface[v.index].combineValue = combineValue;
				// console.log(this.form.get_interface[v.index].combineValue);
				//end
				console.log("change select", this.form.get_interface[16]);
			},
			//图片查看
			viewImg(type) {
				// console, log('查看了吗');
				this.viewImgUrl = this.form.base[type];
				this.dialogVisible = true;
			},
			beforeUpload(file, rules) {
				var tp = file.name.split(".")[1];
				// console.log('beforeUpload');
				// return false
				if (rules) {
					if (rules.type.indexOf(tp) == -1) {
						this.$message.warning("不支持的上传类型");
						return false;
					} else if (file.size > rules.size) {
						this.$message.warning("文件内容过大");
						return false;
					}
				} else {
					this.$message.error("文件读取错误");
					return false;
				}
			},
			upload(val, type) {
				// log(val, type, 'upload');
				let client = new OSS(this.$bus.config.ossConfig);
				let file = val.file;
				let _this = this;
				let id = this.$bus.config.dangan + "/t" + Date.now() + "s" + file.size + "/" + file.name;

				var fileList = null;

				this.$set(this.fileList, id, {
					name: file.name,
					size: file.size,
					uploading: true,
					uid: file.uid,
					time: 0,
					progress: 0,
					key: id,
					client: client,
					type: type,
				});
				fileList = this.fileList;
				// _this.getTimes(file, id)
				// 定义上传方法。

				function multipartUpload(fileList) {
					// log(fileList, 'fileList');
					fileList[id].client
						.multipartUpload(id, file, {
							checkpoint: fileList[id] ? fileList[id].data : null,
							progress: (p, checkpoint, res) => {
								//log(p,checkpoint,res)
								if (checkpoint) {
									fileList[id].progress = p * 100;
									fileList[id].data = checkpoint;
								}
							},
							partSize: 1000 * 1024, //设置分片大小
							timeout: 120000, //设置超时时间
							mime: val.type,
						})
						.then((res) => {
							console.log(res, "set image");
							fileList[id].progress = 100;
							fileList[id].uploading = false;

							_this.$notify({
								title: "上传成功",
								message: `${fileList[id].name}上传完成`,
								type: "success",
							});
							_this.form.base[type] = "http://zhidui-video.oss-cn-qingdao.aliyuncs.com" + res.name;

							// var stobj = {tr_task_id:_this.uuid,tr_baogao_address,tr_sub_status:1,tr_shengcheng_status:1,tr_baogao_xingshi:0}
							// _this.$post('/api-b/tr/plan/baogaoaddress',stobj).then(data=>{

							//     _this.getList()
							// })
						})
						.catch((err) => {
							if (err.code == "RequestError" || err.code == "ConnectionTimeoutError") {
								//网络错误或超时
								setTimeout(multipartUpload, 3000);
							}
						});
				}

				multipartUpload(fileList);
			},
			getShui() {
				var c_name = this.form.base.c_name;
				if (!c_name) {
					this.$message.error("请输入单位名称");
					return false;
				}
				this.shuiLoading = true;
				this.$post("/trxf/main/xf/qyshcx", { c_name }).then((res) => {
					if (res.data.data.result == 1) {
						this.form.base.c_imployee_number = res.data.data.details[0].creditCode;
					} else {
						this.$message.warning(res.data.data.description);
					}
					this.shuiLoading = false;
				});
			},
			getMapCode(id) {
				this.$post("/devicemanage/mapcode", { mc_parent_id: id }).then((res) => {
					this.$store.commit("addMapList", { key: id, value: res.data });
				});
			},
			handlechange() {
				let array=[]
				this.form.base.c_port = this.services.join(",");
				// console.log(this.services,this.form.base.portStr,11111111111111111);
				this.services.forEach((item,index)=>{
					if (item=='1') {
						array.push('评估')
					}else if (item=='2') {
						array.push('维保')
					}else if (item=='3') {
						array.push('监控')
					}else if (item=='4') {
						array.push('电检')
					}else if (item=='5') {
						array.push('消检')
					}else if (item=='6') {
						array.push('验收')
					}
				})
				this.form.base.portStr=array.join(',')
			},
			// 选择单位性质
			handleChangeUnit(v) {
				// alert(this.unitnatureValue)
				this.form.base.unit_nature = v ? v.join(",") : "";
				this.form.base.dangerous_capacity = null;
			},
			async getList() {
				await this.$get("/trxf/main/xf/danwei/xfdanweixinxi/detailbase/" + this.id).then((res) => {
					// log(res, 'get deital');
					this.get_transmission_select = res.from.get_transmission_select;
					this.get_transmission = res.from.get_transmission;
					var {
						from: { get_build },
						from,
					} = res;

					if (get_build.length) {
						get_build.map((item, index) => {
							item.old_name = item.cb_name;
						});
					}

					//  this.unitnatureValue =  res.from.base.unit_nature ? res.from.base.unit_nature.split(',') : []
					var nature = res.from.base.unit_nature ? res.from.base.unit_nature.split(",") : [];
					nature = nature.map((it) => {
						return Number(it);
					});
					this.$set(this, "unitnatureValue", nature);
					this.form = res.from;

					//add code
					this.form.get_interface.forEach((item) => {
						item.combineValue = {
							ci_message_type: item.ci_message_type,
							relayType: item.relayType,
						};
					});
					// console.log(this.form.get_interface);
					//end add
					if (this.form.base.c_build_list) {
						var str = this.form.base.c_build_list;
						var arr1 = str.split(",");
						var arr = [];
						for (var i = 0; i < arr1.length; i++) {
							arr.push(Number(arr1[i]));
						}
						this.checkList = arr;
					}
					// log(res, 111111111111);
					if (res.from.base.c_city == null) {
						// log('没有街道')
						this.$set(this, "areaValue", [res.from.base.c_province]);
					}else if (res.from.base.c_area == null) {
						// log('没有街道')
						this.$set(this, "areaValue", [res.from.base.c_province, res.from.base.c_city]);
					}else if (res.from.base.c_street == null) {
						log('没有街道')
						this.$set(this, "areaValue", [res.from.base.c_province, res.from.base.c_city, res.from.base.c_area]);
					} else {
						// log('正常 ')
						this.$set(this, "areaValue", [res.from.base.c_province, res.from.base.c_city, res.from.base.c_area, res.from.base.c_street || null]);
						// log(this.areaValue, '正常 ');
					}

					// }
					 log(this.areaValue, 333);

					//this.areaValue = [res.from.base.c_province,res.from.base.c_city,res.from.base.c_area]
					if (this.form.base.c_port.charAt(0) === ",") {
						this.form.base.c_port = this.form.base.c_port.substring(1, this.form.base.c_port.length);
					}
					this.services = this.form.base.c_port.split(",");
				});
				if (this.form.base.buildApprovalProcedureInfoURL == "null") {
					this.form.base.buildApprovalProcedureInfoURL = "";
				}
				if (this.form.base.buildDrawInfoURL == "null") {
					this.form.base.buildDrawInfoURL = "";
				}

				// this.$post("/checklist/seruritytablefindone", {
				//   c_company_num: this.$route.query.id,
				// }).then((res) => {
				//   if (res.data.length) {
				//     var data = JSON.parse(res.data[0].company_json).base.ww_problem;
				//     this.form.base.c_firefighting_messsage = data;
				//   }
				// });
			},

			areaChange(val) {
				// this.$refs.cascader.toggleDropDownVisible()
				// log(val);
				if(val.length==1){
					this.form.base.c_province = val[0];
					this.form.base.c_city = null
					this.form.base.c_area = null
					this.form.base.c_street = null
				}else if(val.length==2){
					this.form.base.c_province = val[0];
					this.form.base.c_city = val[1];
					this.form.base.c_area = null
					this.form.base.c_street = null
				}else if(val.length==3){
					this.form.base.c_province = val[0];
					this.form.base.c_city = val[1];
					this.form.base.c_area = val[2];
					this.form.base.c_street = null
				}else if(val.length==4){
					this.form.base.c_province = val[0];
					this.form.base.c_city = val[1];
					this.form.base.c_area = val[2];
					this.form.base.c_street = val[3];
				}
				// this.form.base.c_province = val[0];
				// this.form.base.c_city = val[1];
				// this.form.base.c_area = val[2];
				// this.form.base.c_street = val[3];
				// log(this.form.base.c_street);
			},
			getLoa(val) {
				this.form.base.lon = String(val[0]);
				this.form.base.lat = String(val[1]);
			},
			proChanege(flag) {
				this.cityList = [];
				this.areaList = [];
				flag !== 1 && (this.form.base.c_city = "");
				flag !== 1 && (this.form.base.c_area = "");
				flag !== 1 && (this.form.base.c_street = "");
				this.allAreaList.forEach((it) => {
					if (it.area_code == this.form.base.c_province) {
						this.cityList = it.city;
					}
				});
			},
			// cityChanege(flag) {
			//   this.areaList = [];
			//   !flag && (this.form.base.c_area = "");
			//   this.cityList.forEach((it) => {
			//     if (it.area_code == this.form.base.c_city) {
			//       this.areaList = it.get_area;
			//     }
			//   });
			// },
			addList(index) {
				let obj = {};
				this.tabList[this.nowIndex].data.forEach((it) => {
					obj[it.form_name] = "";
				});
				obj.hide = false;
				if (this.tabList[this.nowIndex].data >= 20) {
					// log(123);
				}
				this.form[this.tabList[this.nowIndex].form].push(obj);

				// 移动到底部
				this.$nextTick(() => {
					this.$refs.subBtn?.scrollIntoView({ behavior: "smooth", inline: "nearest" });
				});
			},

			del(index) {
				this.form[this.tabList[this.nowIndex].form].splice(index, 1);
			},
			changeTab(index) {
				// console.log(index, 11111111);
				this.nowIndex = index;
			},
			onSubmit() {
				// this.getList();

				// console.log(this.$refs.form.validate, 'this.$refs.form');
				this.$refs.form.validate((valid) => {
					if (valid) {
						// console.log(11111);
						var arr = this.checkList;
						var str = arr.join(",");
						this.form.base.c_build_list = str;
						this.form.base.unit_nature = this.unitnatureValue.join(",");
						this.save();
					} else {
						this.nowIndex = 0;
						return false;
					}
				});
			},
			//模板下载
			downmuban() {
				var url = `${this.$config.apiUrl}/trxf/main/xf/danwei/dianwei/downloadmoban?c_company_num=${this.form.base.c_company_num}`;
				window.open(url, "_blank");
			},
			//文件上传成功
			handlesuccess(res) {
				if (res.code == 500) {
					this.$message.error("导入失败，检查文件模板");
				} else {
					// this.$message.success("导入成功");
					this.$message({
                message: '导入成功',
                type: 'success',
                duration: 700,
              });
					console(res, "shangchuan");
					this.getList();
				}
			},

			save() {
				var int = [
					"c_type",
					"c_net_status",
					"c_setup_table",
					"c_import_company",
					"zd_facility",
					"c_imployee_number ",
					"c_manager_phone  ",
					"c_safe_level",
					"c_belong_profession",
					"c_woker",
					"c_land_area",
					"c_total_area",
					"c_plugin_type",
					"cb_height",
					"cb_on",
					"cf_node",
					"cf_quantity",
					"ci_message_type",
					"ci_sys_type",
					"ci_port",
					"cm_push",
					"cd_type",
					"ct_transmission_type",
					"ct_child_number",
					"ct_part_num",
					"ct_heart_beat",
				];
				for (var key in this.form) {
					int.forEach((it) => {
						if (this.form.base[it]) {
							this.form.base[it] = +this.form.base[it];
						}
						if (key != "base") {
							this.form[key].forEach((im) => {
								if (im[it]) {
									im[it] = +im[it];
								}
							});
						}
					});
				}
				// console.log(this.form.get_build)
				var build_list = this.form.get_build;
				for (var i = 0; i < build_list.length; i++) {
					var item = build_list[i].cb_name;
					for (var j = i + 1; j < build_list.length; j++) {
						if (item === build_list[j].cb_name) {
							this.$message.warning("建筑名称不可以相同");
							return false;
						}
					}
				}

				var get_transmission = this.form.get_transmission;
				if (get_transmission.length) {
					for (var i = 0; i < get_transmission.length; i++) {
						if (!get_transmission[i].ct_transmission_num) {
							this.$message.warning("传输设备编号不可为空");
							return false;
						}
					}
				}

				var get_interface = this.form.get_interface;

				if (get_interface.length) {
					for (var i = 0; i < get_interface.length; i++) {
						if (!get_interface[i].ci_num) {
							this.$message.warning("接口资料编号不可为空");

							return false;
						} else if (get_interface[i].ci_message_type == 172 && !get_interface[i].ci_device_name) {
							this.$message.warning("信号名称不可为空");
							return false;
						}
						if (!get_interface[i].water_height) {
							get_interface[i].water_height = "0";
						}
					}
				}
				console.log('处理逻辑',this.form.base)
				// this.form.base.c_firefighting_messsage = "";
				let logading = this.$loading({ background: "rgba(0, 0, 0, 0.6)" });
				if (!this.id || !this.form.base.c_id) {
					console.log('xiznmeng');
					
					addCompany(this.form)
						.then((res) => {
							console.log(res,'新增');
							
							// if (res.code == 500) {
							//   this.$message.warning(res.msg);

							//   return false;
							// }
							if (res.code == 200) {
								// this.$message.success("保存成功");
								this.$message({
									message: '保存成功',
									type: 'success',
									duration: 700,
								});
								this.$router.back();
							}
							logading.close();
						})
						.catch((res) => {
							logading.close();
						});
				} else {
					console.log('xiugai');

					editCompany(this.form)
						.then((res) => {
							console.log(res,'修改');

							// if (res.code == 500) {
							//   this.$message.warning(res.msg);
							//  logading.close();

							//   return false;
							// }
							if (res.code == 200) {
								// this.$message.success("保存成功");
								this.$message({
									message: '保存成功',
									type: 'success',
									duration: 700,
								});
								// this.$router.back();
							}
							logading.close();
						})
						.catch((res) => {
							logading.close();
						});
				}
			},
		},
	};
</script>

<style scoped lang="scss">
	.titlepanel {
		position: relative;
	}
	#panel {
		width: 200px;
		height: 200px;
		background-color: #d6d3d381;
		position: absolute;
		top: 42%;
		left: 15%;
		transform: translate(-50%, -50%);
		z-index: 999;
	}

	::v-deep .el-select {
		width: 100%;
	}
	.fireFacilities {
		display: flex;
		justify-content: space-between;
	}
	.firehead {
		margin: 0 30px 30px 30px;
	}
	.fireFightingLeft {
		width: 18%;
	}
	.fireCenter {
		width: 1px;
		/* height: 100vh; */
		border: 1px dashed rgb(172, 172, 172);
	}
	.fireFightingRight {
		width: 75%;
	}
	.firebiao {
		margin-left: 30px;
	}
	.fireHead {
		margin-top: -1px;
		padding: 10px 30px;
		border: 1px solid black;
		margin-bottom: -1px;
		cursor: pointer;
	}
	.fireHead:hover {
		background-color: rgb(212, 233, 242);
		font-weight: bolder;
	}
	.fireHead1 {
		margin-top: -1px;
		padding: 10px 30px;
		border: 1px solid black;
		margin-bottom: -1px;
		cursor: pointer;
		background-color: rgb(212, 233, 242);
		font-weight: bolder;
	}
	::v-deep .el-collapse {
		border: none;
	}
	::v-deep .el-collapse-item__wrap,
	.el-collapse-item__header {
		border: none;
	}
	::v-deep .el-collapse-item__header {
		border: none;
	}
	::v-deep .el-collapse-item__header {
		height: 30px;
	}
	.fireFightingRight_border {
		padding: 3px;
		margin: 3px;
		border: 1px solid rgba(172, 172, 172, 0.5);
		border-radius: 10px;
	}
	.monitor {
		display: flex;
		/* justify-content: space-between; */
	}
	.monitor_device {
		width: 40%;
		display: inline-block;
		margin: 7px 0 10px 10px;
	}
	.monitor_count {
		/* margin-top: 1px; */
	}
	.pulldown {
		width: 30px;
		height: 30px;
	}
	.fireFightingRight_count {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		min-width: 1000px;
		/* display: grid; */
		/* justify-content: space-between; */
		/* align-content: flex-start; */
		/* align-items: flex-start; */
		/* grid-template-columns: repeat(auto-fill, 1080px); */
		/* grid-gap: 0px 80px; */
		border-bottom: 1px dashed rgb(172, 172, 172);
		padding: 10px 0;
		margin-left: 10px;
	}
	.fireFightingRight_count_detail1 {
		/* display: flex; */
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		min-width: 100%;
		/* width: calc((100% - 22px) / 3); */
		/* justify-content: space-between; */
	}
	.fireInput {
		height: 35px;
	}
	.fireFightingRight_count_detail {
		display: flex;
		margin-bottom: 10px;
		width: calc((100% - 32px) / 3);
	}
	.fireQuestion {
		margin: 10px 0px;
	}
	.fireQuestionP {
		margin-bottom: 5px;
	}
	::v-deep .Devicetype {
		width: 10% !important ;
	}

	.is-right {
		position: absolute;
		right: 0;
		top: 6px;
		padding-right: 12px;
	}

	.sortHead .drgText {
		font-size: 14px;
		color: #323233;
		font-weight: 700;
	}

	.is-right .el-button {
		cursor: pointer !important;
	}

	//拖动排序样式
	.dragClass {
		border-radius: 4px;
		opacity: 1;
		border: 5px solid green !important;
	}

	.fallbackClass {
		border-radius: 4px;
		opacity: 1;
		border: 1px solid #adc1ef !important;
	}

	.chosenClass {
		color: #fff !important;
		border-radius: 4px;
		opacity: 1 !important;
		background: rgb(248, 249, 250);
		// border: 5px solid pink;
	}

	.ghostClass {
		opacity: 0.7 !important;

		// border: 5px solid saddlebrown;
	}

	.draggable {
		cursor: pointer;
		width: 141px;
		height: 100px;
	}
	.caozuo {
		width: 100%;
		display: flex;
		justify-content: center;
	}
	.trtdflex {
		display: flex;
		justify-content: space-around;
	}
::v-deep .el-radio__inner {
    display: none;
}
// 级联选择器el-cascader，通过点击label文字部分选中



</style>
